import { $themeBreakpoints } from "@themeConfig";
import axiosIns from "@/libs/axios";

let fetchCompanyInflight = null;
let fetchCompanyInflightId = null;

export default {
  namespaced: true,
  state: {
    password: null,
    windowWidth: 0,
    shallShowOverlay: false,
    language: "de",
    avatarImg: "",
    profileImg: "",
    hasInvoice: false,
    hasDocs: false,
    company:null,
    watchCompany:null,
    firstTask:false,
    countries:[],
    countries_code:[],
    fileBase64:'',
    fileType:'',
    sidebar:false,
    level: null,
  },
  getters: {
    currentBreakPoint: (state) => {
      const { windowWidth } = state;
      if (windowWidth >= $themeBreakpoints.xl) return "xl";
      if (windowWidth >= $themeBreakpoints.lg) return "lg";
      if (windowWidth >= $themeBreakpoints.md) return "md";
      if (windowWidth >= $themeBreakpoints.sm) return "sm";
      return "xs";
    },
    getFileUrl(){
      return state.fileBase64
    },
    getFileType(){
      return state.fileType
    },
    checkRequiredSigningGate() {
      if (typeof window !== 'undefined' && typeof window.__aeqRequireSigningGate === 'function') {
        return window.__aeqRequireSigningGate() === true
      }
      return false
    }
  },
  mutations: {
    UPDATE_PASSWORD(state, val) {
      state.password = val
    },
    UPDATE_LANGUAGE(state, val) {
      state.language = val;
    },
    UPDATE_LEVEL(state, val) {
      state.level = val;
    },
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val;
    },
    SET_COUNTRIES_LIST(state, array){
     state.countries = array
    },
    SET_COUNTRIES_CODE_LIST(state,array){
      state.countries_code = array
    },
    
    SET_COMPANY_INFO(state,company){

         state.company = company
    },
    COMPANY_INFO(state,company){
        state.watchCompany = company
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay =
        val !== undefined ? val : !state.shallShowOverlay;
    },
    SET_AVATAR_HEADER(state, avatar) {
      state.avatarImg = avatar;
    },
    SET_PROFILE_HEADER(state, profile) {
      state.profileImg = profile;
    },
    CHECK_FOR_INVOICE(state, bool) {
      state.hasInvoice = bool;
    },
    CHECK_FOR_DOCS(state, bool) {
      state.hasDocs = bool;
    },
    FIRST_TASK_STATUS(state, bool){
      state.firstTask = bool
    },
    SET_FILE_BASE64(state, url){
        state.fileBase64 = url
    },
    SET_FILE_TYPE(state, url){
      state.fileType = url
    },
    ON_SIDEBAR_CLICK(state,sidebar){
      state.sidebar = sidebar
    }
  },
  actions: {
    fetchCompany({ state, commit, rootState }, { companyId, force = false } = {}) {
      const id = companyId ?? rootState.auth?.user?.company_id ?? state.company?.value?.id;
      if (!id) {
        return Promise.resolve(null);
      }

      if (!force && state.company?.value?.id === id) {
        return Promise.resolve(state.company);
      }

      let request = fetchCompanyInflight;
      if (force || !request || fetchCompanyInflightId !== id) {
        fetchCompanyInflightId = id;
        request = axiosIns
          .post(`/company/show/${id}`)
          .then((res) => res?.data ?? null)
          .finally(() => {
            fetchCompanyInflight = null;
            fetchCompanyInflightId = null;
          });
        fetchCompanyInflight = request;
      }

      return request.then((data) => {
        if (data) {
          commit("SET_COMPANY_INFO", data);
          commit("COMPANY_INFO", data);
          if (data.value?.level != null) {
            commit("UPDATE_LEVEL", data.value.level);
          }
        }
        return data;
      });
    },
  },
};
